import { useSelector } from 'react-redux';
import { MenuTaxonomyState } from '@/reducers/menuTaxonomy';

export default function useMenuTaxonomyTitles() {
  const menuTaxonomyTitles = useSelector(
    (state: { menuTaxonomy: MenuTaxonomyState }) => state.menuTaxonomy.menuTaxonomyTitles
  );

  return menuTaxonomyTitles;
}
